export const constants = {
    awsAccessKeyId: 'AKIASET6W74RYBM7ROV2',
    awsSecretAccessKey: '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'
};
